import useApi from "./useApiRequest";
import { useMutation } from "react-query";


export const UpdateDomicilio = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/domicilios/${params.id}`, params.data, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        updateDomicilioMutation: mutation.mutate,
    };
}